import React, { useContext } from 'react';
import { Salary } from 'module-tsl-ui-jobs-salary';
import { JobContext } from '../JobContext';
export var SalaryDescription = function SalaryDescription() {
  var context = useContext(JobContext);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Salary: "), /*#__PURE__*/React.createElement(Salary, context));
};
SalaryDescription.displayName = "SalaryDescription";